import React from 'react'
import PurchasesTable from './PurchasesTable'
import TransactionsTable from './TransactionsTable'
import Seller from './Seller'

const Purchase = (props) => {
  const { redelivery } = props
  const purchases = redelivery?.purchases || []
  const transactions = redelivery?.transactions || []

  return (
    <>
      <PurchasesTable purchases={purchases} />
      <TransactionsTable transactions={transactions} />
      <Seller {...props} />
    </>
  )
}

export default Purchase
